import ModuleContext from 'CMFW/context/ModuleContext';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerRight, ModuleContainer } from 'components/common/styles';
import { useForceRender } from 'hooks/useForceRender';
import React, { useContext, useEffect, useMemo } from 'react';
import ActiveInflectTemplatesActiveModel from '../../../models/ActiveInflectTemplatesActiveModel';
import InflectTables from '../../../components/inflect/table/InflectTables';
import styled from 'styled-components';
import ActiveInflectTemplatesModel from '../../../models/ActiveInflectTemplatesModel';
import ActiveInflectCellRenderer from './ActiveInflectCellRenderer';

export type IProps = {
  courseId: number;
  templateId: number;
  wordClassId: number;
};

const ActiveInflectCells: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const moduleModel = useContext(ModuleContext) as ActiveInflectTemplatesModel;
  const activeInflectsModel = useMemo(
    () =>
      new ActiveInflectTemplatesActiveModel({
        render: forceRender,
        courseId: props.courseId,
      }),
    [props.courseId, forceRender],
  );

  moduleModel.onSave = async (templateId) => {
    activeInflectsModel.setTemplateId(templateId);
    await activeInflectsModel.save();
  };

  useEffect(() => {
    if (props.templateId > 0 && props.wordClassId > 0) {
      activeInflectsModel.loadTemplate(props.templateId, props.wordClassId);
    }
  }, [activeInflectsModel, props.templateId, props.wordClassId]);

  if (moduleModel.getItemId() <= 0) {
    return <ContainerRight />;
  }

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={activeInflectsModel}>
        <ContainerRight>
          <Scroll>
            <InflectTables cellRenderer={<ActiveInflectCellRenderer keyName={'active'} />} showTrash={true} />
          </Scroll>
        </ContainerRight>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

const Scroll = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export default ActiveInflectCells;